import "core-js/modules/es.array.push.js";
const __default__ = {
  name: "DashboardView",
  filters: {
    trim: function (value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    }
  },

  data() {
    return {
      isLoading: {
        attendance: true,
        message: true,
        enquete: true
      },
      pollingCount: 0,
      showModal: false,
      pageTitle: "",
      attendances: [],
      absentList3: [],
      absentList20: [],
      absentList30: [],
      date: "",
      currentDt: "",
      intervalId: null,
      observer: null,
      isGradeTables: true,
      attendanceDetailsTableData: [],
      todayAttendance: [],
      counterAbsentTotal: null,
      counterLunchSkipTotal: null
    };
  },

  head: {
    title: function () {
      return {
        inner: "ダッシュボード"
      };
    },
    meta: []
  },
  computed: { ...mapState(["school", "studentAddress", "news", "showElevatingNotice"]),

    schoolAbsentTotal() {
      if (this.isGradeTables) {
        return this.todayAttendance.filter(a => a.type.split("-")[0] === "欠席").length;
      }

      return this.counterAbsentTotal;
    },

    schoolLunchSkipTotal() {
      if (this.isGradeTables) {
        return this.todayAttendance.filter(a => a.type.includes("給食×")).length;
      }

      return this.counterLunchSkipTotal;
    }

  },
  watch: {
    isGradeTables(newVal) {
      // isGradeTablesの変更に応じてintervalを制御
      if (newVal) {
        // trueの場合、Index.vueのintervalを開始
        this.startInterval();
      } else {
        // falseの場合、Index.vueのintervalを停止
        this.stopInterval();
      }
    }

  },

  created() {
    this.setData();
    this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
  },

  mounted() {
    // 初期状態でisGradeTablesがtrueの場合、intervalを開始
    if (this.isGradeTables) {
      this.startInterval();
    } // 既存のモーダル表示ロジック


    if (this.me.role_id <= 11 && !this.showElevatingNotice && this.school.elevating && this.school.elevating.date) {
      const firstDateOfMarch = moment().startOf("year").add(2, "month");
      const firstDateOfApril = moment().startOf("year").add(3, "month");

      if (moment().isAfter(firstDateOfMarch) && moment().isBefore(firstDateOfApril)) {
        const message = "生徒名簿・出席簿のダウンロードはお済みですか？" + this.school.elevating.date + "までに対応が必要です。";
        this.$store.dispatch("commitModalMessage", {
          message: message,
          title: ""
        });
        this.$store.dispatch("commitShowElevatingNotice", true);
        this.showModal = true;
      }
    }
  },

  beforeDestroy() {
    this.stopInterval();
  },

  methods: {
    toggleDashboard: function (showTable) {
      this.isGradeTables = showTable;
    },

    async setData() {
      this.date = moment().format("YYYY/MM/DD");
      await this.getAttendance(true);
      this.isLoading.attendance = false;
    },

    async getAttendance(calcBadge) {
      if (calcBadge) {
        const a = await getAbsentAlert();
        this.absentList3 = a.absentList3;
        this.absentList20 = a.absentList20;
        this.absentList30 = a.absentList30;
      }

      const data = await getData("attendances?limit=300&with=student.classroom&from=" + moment().format("YYYY-MM-DD") + "&with_book_label=1&show_daily_all=1&orderby=updated_at&order=DESC");
      const attendances = data.items;
      this.attendances = attendances.sort((a, b) => {
        // まず updated_at で降順
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        if (dateA > dateB) return -1;
        if (dateA < dateB) return 1; // 同じ updated_at の場合、id で降順

        return b.id - a.id;
      }).map(a => {
        a.absents = assignAbsentBudge(a.student, this.absentList3, this.absentList20, this.absentList30);
        a.date = moment(a.date).format("YYYY年MM月DD日");
        a.created_at = moment(a.created_at).format("MM月DD日 HH時mm分");
        a.classroom_name = a.student && a.student.classroom ? a.student.classroom.name : null;
        a.typeText = Text.attendances.type[a.type];
        a.isHistory = Boolean(!a.is_daily_latest && attendances.filter(v => v.student_id === a.student_id && v.to_date === a.to_date).length > 1);
        return a;
      }); //大規模校向けテーブルのデータを生成のため今日分のデータを抽出する

      const today = moment().format("YYYY年MM月DD日");
      this.todayAttendance = this.attendances.filter(v => v.date === today && v.is_daily_latest);
    },

    startInterval() {
      if (!this.intervalId) {
        this.getAttendance(false);
        this.intervalId = setInterval(() => {
          this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
          this.pollingCount++;
          this.getAttendance(this.pollingCount % 180 === 0);
        }, 1000 * 60 * 1);
      }
    },

    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    onUpdateSummary({
      total,
      lunchSkip
    }) {
      this.counterAbsentTotal = total;
      this.counterLunchSkipTotal = lunchSkip;
    },

    updateCurrentTime() {
      this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
    },

    navigateToElevate() {
      this.showModal = false;
      this.$router.push({
        name: "elevate"
      });
    },

    closeMessageModal() {
      this.showModal = false;
    }

  }
};
import { ref, computed, provide } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import Text from "@/consts/text";
import { mapState } from "vuex";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import MessageModal from "../common/MessageModal.vue";
import { getAbsentAlert, assignAbsentBudge, formatPhoneNumber } from "@/services/common";
import { useStore } from "vue2-helpers/vuex"; // モジュール読み込み

import LatestAbsenceInfo from "@/components/dashboard/LatestAbsenceInfo";
import LatestAttendanceCounter from "@/components/dashboard/LatestAttendanceCounter";
import AllClassAbsenceCounter from "@/components/dashboard/AllClassAbsenceCounter";
import GradeTable from "@/components/dashboard/GradeTable"; // import LatestTemperature from "@/components/dashboard/LatestTemperature.vue";

import LatestSchoolForum from "@/components/dashboard/LatestSchoolForum.vue";
import RowItem from "../RowItem";
import LatestGovernmentForum from "@/components/dashboard/LatestGovernmentForum.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const store = useStore();
    const me = computed(() => store.state.me);
    const classrooms = computed(() => store.state.classrooms);
    const phoneAttendance = computed(() => {
      return formatPhoneNumber(store.state.school.phone_attendance);
    });
    const {
      schoolPlan
    } = storeToRefs(useSchoolPlanStore());
    const attendanceMode = ref("counter");
    provide("attendanceMode", attendanceMode);
    expose({
      me,
      classrooms
    });
    return {
      __sfc: true,
      store,
      me,
      classrooms,
      phoneAttendance,
      schoolPlan,
      attendanceMode,
      MessageModal,
      LatestAbsenceInfo,
      LatestAttendanceCounter,
      AllClassAbsenceCounter,
      GradeTable,
      LatestSchoolForum,
      RowItem,
      LatestGovernmentForum
    };
  }

});